import moment from "moment";
import Graph from "../util/graph";

const CollectionConcilationSingleDateFinder = (
    collectionConcilation,
    allDates,
    selectedDates,
    isHotelSummed,
    isDateSummed,
    sHotels,
    options,
    isBar
) => {

    let labels = [...selectedDates]
    let methods = []
    sHotels.forEach((sHotel) => {
        selectedDates.forEach((date) => {
            collectionConcilation[sHotel][date].forEach(cur => {
                let types = Object.keys(cur.data).filter((t) =>
                    options.includes(t)
                );
                types.forEach((curr) => {
                    cur.data[curr].forEach((currr) => {
                        if (!labels.includes(currr.date)) {
                            labels.push(currr.date)
                        }
                        if (!methods.includes(currr.method)) {
                            methods.push(currr.method)
                        }
                    });
                })
            });
        })
    })

    labels = labels.sort((a, b) => {
        let aTime = moment(a, "DD-MMMM").unix()
        let bTime = moment(b, "DD-MMM").unix()
        return aTime - bTime
    })

    if (!isHotelSummed && !isDateSummed) {

        if (isBar) {
            let cData = sHotels.map((sHotel, hIndex) => {
                return selectedDates.map((sDate, dIndex) => {
                    return options.map((option, oIndex) => {
                        return methods.map((method, mIndex) => {
                            return {
                                label: `${sHotel} ${option} ${method} ${sDate} Collection`,
                                data: labels.map((date) => {
                                    let data = collectionConcilation[sHotel][sDate];
                                    return data.reduce((acc, cur) => {
                                        return (
                                            acc + cur.data[option].reduce((acccc, currr) => {
                                                if (date !== currr.date || currr.method !== method) {
                                                    return acccc
                                                }
                                                return acccc + currr.effectiveValue
                                            }, 0)
                                        );
                                    }, 0);
                                }),
                                borderColor: Graph.Colors[hIndex + mIndex + oIndex + dIndex],
                                backgroundColor: Graph.Colors[hIndex + mIndex + oIndex + dIndex],
                                ...Graph.ExtraOptions,
                                stack: `${sHotel} ${sDate} Collection`
                            };
                        })
                    }).flat()
                }).flat()
            }).flat();

            return {
                labels: labels,
                datasets: cData
            }
        }


        let cData = sHotels.map((sHotel, hIndex) => {
            return selectedDates.map((sDate, dIndex) => {
                return {
                    label: `${sHotel} ${sDate} Collection`,
                    data: labels.map((date) => {
                        let data = collectionConcilation[sHotel][sDate];
                        return data.reduce((acc, cur) => {
                            let types = Object.keys(cur.data).filter((t) =>
                                options.includes(t)
                            );
                            return (
                                acc +
                                types.reduce((accc, curr) => {
                                    return accc + cur.data[curr].reduce((acccc, currr) => {
                                        if (date !== currr.date) {
                                            return acccc
                                        }
                                        return acccc + currr.effectiveValue
                                    }, 0);
                                }, 0)
                            );
                        }, 0);
                    }),
                    borderColor: Graph.Colors[hIndex + dIndex],
                    backgroundColor: Graph.Colors[hIndex + dIndex],
                    ...Graph.ExtraOptions,
                };
            })
        }).flat()
        return {
            labels: labels,
            datasets: cData
        }

    } else if (isHotelSummed && !isDateSummed) {

        if (isBar) {
            let cData = selectedDates.map((sDate, dIndex) => {
                return options.map((option, oIndex) => {
                    return methods.map((method, mIndex) => {
                        return {
                            label: `All Hotels ${option} ${method} ${sDate} Collection`,
                            data: labels.map((date) => {
                                return sHotels.reduce((hAcc, sHotel) => {
                                    return hAcc + collectionConcilation[sHotel][sDate].reduce((acc, cur) => {
                                        return (
                                            acc + cur.data[option].reduce((acccc, currr) => {
                                                if (date !== currr.date || currr.method !== method) {
                                                    return acccc
                                                }
                                                return acccc + currr.effectiveValue
                                            }, 0)
                                        );
                                    }, 0);
                                }, 0)
                            }),
                            borderColor: Graph.Colors[oIndex + mIndex + dIndex],
                            backgroundColor: Graph.Colors[oIndex + mIndex + dIndex],
                            ...Graph.ExtraOptions,
                            stack: `All Hotels ${sDate} collection`
                        };
                    })
                }).flat()
            }).flat()

            return {
                labels: labels,
                datasets: cData
            }
        }


        let cData = selectedDates.map((sDate, dIndex) => {
            return {
                label: `All Hotels ${sDate} Collection`,
                data: labels.map((date) => {
                    return sHotels.reduce((hAcc, sHotel) => {
                        return hAcc + collectionConcilation[sHotel][sDate].reduce((acc, cur) => {
                            let types = Object.keys(cur.data).filter((t) =>
                                options.includes(t)
                            );
                            return (
                                acc +
                                types.reduce((accc, curr) => {
                                    return accc + cur.data[curr].reduce((acccc, currr) => {
                                        if (date !== currr.date) {
                                            return acccc
                                        }
                                        return acccc + currr.effectiveValue
                                    }, 0);
                                }, 0)
                            );
                        }, 0);
                    }, 0)
                }),
                borderColor: Graph.Colors[dIndex],
                backgroundColor: Graph.Colors[dIndex],
                ...Graph.ExtraOptions,
            };
        })

        return {
            labels: labels,
            datasets: cData
        }

    } else if (!isHotelSummed && isDateSummed) {

        if (isBar) {
            let rData = selectedDates.map((sDate, dIndex) => {
                return sHotels.map((sHotel, hIndex) => {
                    return options.map((option, oIndex) => {
                        return methods.map((method, mIndex) => {
                            return {
                                label: `${sHotel} ${option} ${method} ${sDate} Collection`,
                                data: [
                                    collectionConcilation[sHotel][sDate].reduce((acc, cur) => {
                                        console.log(cur.data[option])
                                        return (
                                            acc + cur.data[option].reduce((acccc, currr) => {
                                                if (currr.method !== method) {
                                                    return acccc
                                                }
                                                return acccc + currr.effectiveValue
                                            }, 0)
                                        );
                                    }, 0)
                                ],
                                borderColor: Graph.Colors[hIndex + mIndex + oIndex + dIndex],
                                backgroundColor: Graph.Colors[hIndex + mIndex + oIndex + dIndex],
                                ...Graph.ExtraOptions,
                                stack: `${sHotel} ${sDate} Collection`
                            };
                        })
                    }).flat()
                }).flat();
            }).flat()

            return {
                labels: ["Revenue And Collection"],
                datasets: rData
            }
        }

        let cData = selectedDates.map((sDate, dIndex) => {
            return sHotels.map((sHotel, hIndex) => {
                return {
                    label: `${sHotel} ${sDate} Collection`,
                    data: [
                        collectionConcilation[sHotel][sDate].reduce((acc, cur) => {
                            let types = Object.keys(cur.data).filter((t) =>
                                options.includes(t)
                            );
                            return (
                                acc +
                                types.reduce((accc, curr) => {
                                    return accc + cur.data[curr].reduce((acccc, currr) => {
                                        return acccc + currr.effectiveValue
                                    }, 0);
                                }, 0)
                            );
                        }, 0)
                    ],
                    borderColor: Graph.Colors[hIndex + dIndex],
                    backgroundColor: Graph.Colors[hIndex + dIndex],
                    ...Graph.ExtraOptions,
                };
            })
        }).flat()

        return {
            labels: ["Revenue And Collection"],
            datasets: cData
        }

    } else if (isHotelSummed && isDateSummed) {

        if (isBar) {

            let cData = options.map((option, oIndex) => {
                return methods.map((method, mIndex) => {
                    return {
                        label: `All Hotels ${option} ${method} Collection`,
                        data: [
                            selectedDates.reduce((dAcc, dCur) => {
                                return dAcc + sHotels.reduce((hAcc, sHotel) => {
                                    return hAcc + collectionConcilation[sHotel][dCur].reduce((acc, cur) => {
                                        return (
                                            acc + cur.data[option].reduce((acccc, currr) => {
                                                if (currr.method !== method) {
                                                    return acccc
                                                }
                                                return acccc + currr.effectiveValue
                                            }, 0)
                                        );
                                    }, 0)
                                }, 0)
                            }, 0)
                        ],
                        borderColor: Graph.Colors[oIndex + mIndex],
                        backgroundColor: Graph.Colors[oIndex + mIndex],
                        ...Graph.ExtraOptions,
                        stack: "All Hotels Collection"
                    };
                })
            }).flat()

            return {
                labels: ["Revenue And Collection"],
                datasets: cData
            }
        }



        let cData = {
            label: `All Hotels Collection`,
            data: [
                selectedDates.reduce((dAcc, dCur) => {
                    return dAcc + sHotels.reduce((hAcc, sHotel) => {
                        return hAcc + collectionConcilation[sHotel][dCur].reduce((acc, cur) => {
                            let types = Object.keys(cur.data).filter((t) =>
                                options.includes(t)
                            );
                            return (
                                acc +
                                types.reduce((accc, curr) => {
                                    return accc + cur.data[curr].reduce((acccc, currr) => {
                                        return acccc + currr.effectiveValue
                                    }, 0);
                                }, 0)
                            );
                        }, 0)
                    }, 0)
                }, 0)
            ],
            borderColor: Graph.Colors[1],
            backgroundColor: Graph.Colors[1],
            ...Graph.ExtraOptions,
            stack: "All Hotels Collection"
        };


        return {
            labels: ["Revenue And Collection"],
            datasets: [cData]
        }
    }
}

export default CollectionConcilationSingleDateFinder